import type { FirestoreError } from 'firebase/firestore';
import type { Project } from '@altyor-kronos/shared-types';
import { usePolledResource } from '../../core/data/usePolledResource';
import { apiList } from '../../core/data/restClient';

export interface ClientProjectsState {
  rows: Array<{ id: string; data: Project }>;
  loading: boolean;
  error: FirestoreError | null;
}

export function useClientProjects(open: boolean, clientId: string | null): ClientProjectsState {
  // Server orders projects by name asc and filters clientId (convenience filter,
  // projects are world-readable). Idle until the modal opens with a client.
  const { rows, loading, error } = usePolledResource<Project & { id: string }>(
    open && clientId ? clientId : null,
    () => apiList<Project & { id: string }>('/projects', { clientId: clientId ?? undefined }),
  );
  return {
    rows: rows.map((r) => ({ id: r.id, data: r })),
    loading,
    error: error as FirestoreError | null,
  };
}
